import Component from '@glimmer/component';

interface UiCheckboxSignature {
  Element: HTMLInputElement;
  Args: {
    Named: {
      checked?: boolean;
    };
  };
}

export default class UiCheckboxComponent extends Component<UiCheckboxSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Checkbox': typeof UiCheckboxComponent;
    'ui/checkbox': typeof UiCheckboxComponent;
  }
}
